import React from 'react';
import { Section, Wrap } from '@fiverr-private/layout_components';
import { Box } from '@fiverr-private/theme';
import { useAppContext } from '../../../context/listingsContext';
import { hiddenScrollbarStyles } from '../../hidden_scrollbar/hiddenScrollbar.ve.css';
import { SuggestionTagItem } from './components/SuggestionTagItem';
import { bleedStyles } from './SuggestionsRow.ve.css';

const EDGE_PADDING = '6';
const DESKTOP_MAX_HEIGHT = '80px';

export const SuggestionsRow = () => {
    const { suggestions, isTouch } = useAppContext();

    if (!suggestions.length) {
        return null;
    }

    if (isTouch) {
        return (
            <Section className="layout-row content-row">
                <Box className={bleedStyles} marginTop="3">
                    <Wrap
                        className={hiddenScrollbarStyles}
                        gap="2"
                        wrap="nowrap"
                        overflowX="auto"
                        paddingX={EDGE_PADDING}
                    >
                        {suggestions.map((label: string, index: number) => (
                            <SuggestionTagItem key={label} label={label} position={index + 1} />
                        ))}
                    </Wrap>
                </Box>
            </Section>
        );
    }

    return (
        <Section className="layout-row content-row">
            <Wrap
                gap={{ default: '2', md: '3' }}
                wrap="wrap"
                marginTop="6"
                overflow="hidden"
                style={{ maxHeight: DESKTOP_MAX_HEIGHT }}
            >
                {suggestions.map((label: string, index: number) => (
                    <SuggestionTagItem key={label} label={label} position={index + 1} />
                ))}
            </Wrap>
        </Section>
    );
};
